import { createAsyncThunk } from '@reduxjs/toolkit';

import { TransactionsService } from 'api';

import { FilterDateParams } from 'models';

export const getTransactions = createAsyncThunk(
	'statement/getTransactions',
	async (params: { params: FilterDateParams }) => {
		return await TransactionsService.get(params);
	},
);
